import { AxiosResponse, AxiosStatic } from "axios";

export interface ILogoutApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface ILogoutApi {
  delete: () => Promise<AxiosResponse>;
}

export default class LogoutApi implements ILogoutApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: ILogoutApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public delete = () => {
    return this.axios.delete(`${this.apiRoot}/sessions`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  };
}
